export const controller = new ScrollMagic.Controller();
